import * as React from "react";
import MuiCircularProgress, {
    CircularProgressProps as MuiCircularProgressProps,
    CircularProgressClassKey as MuiCircularProgressClassKey
} from "@material-ui/core/CircularProgress";

export type CircularProgressClassKey = MuiCircularProgressClassKey;

export interface CircularProgressProps extends MuiCircularProgressProps { }

class CircularProgress extends React.PureComponent<CircularProgressProps> {
    render() {
        const { ...props } = this.props;
        return <MuiCircularProgress {...props}>
            {this.props.children}
        </MuiCircularProgress>;
    }
}

export default CircularProgress;